import BlankLayout from '../../../layout/blankLayout.vue'
import List from './list.vue'
import { OFFER_LETTER_PAGE_TYPE } from '@/constant/company'

const basePath = '/v-admin/offer-letter-management/invite'
const pageType = OFFER_LETTER_PAGE_TYPE.INVITE_RECORD

export default {
  path: `${basePath}`,
  component: BlankLayout,
  redirect: `${basePath}/list`,
  meta: {
    isNewPage: true,
    titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterInviteRecordList'
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        permission: 'PERM_OFFER_INITIATE',
        pageType: pageType,
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterInviteRecordList'
      }
    }
  ]
}
